import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { ButtonGhost } from "./Button/Button";
import { ReactComponent as BusinessIcon } from "../assets/icons/business.svg";

const CaseNumberLabel = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.neutral800};
  margin-bottom: 8px;
`;

const CaseNumberValue = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.netural800};
`;

const Description = styled.p`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.neutral800};
  margin-bottom: 24px;
  text-align: left;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 500px;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    width: 100%;
  }
`;

export interface ContactModalContentProps {
  caseNumber?: string;
}

export default function ContactModalContent({ caseNumber }: ContactModalContentProps) {
  const { t } = useTranslation();
  const handleMailClick = () => {
    window.location.href = `mailto:support@blockben.com?subject=`;
  };

  return (
    <ContentWrapper>
      <CaseNumberLabel>{t("contactModal.caseNumberLabel")}</CaseNumberLabel>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "8px",
          justifyContent: "center",
          marginBottom: 32
        }}
      >
        <BusinessIcon />
        <CaseNumberValue>{caseNumber}</CaseNumberValue>
      </div>
      <Description>{t("contactModal.description")}</Description>
      <ButtonGhost onClick={handleMailClick}>
        {t("contactModal.button")}
      </ButtonGhost>
    </ContentWrapper>
  );
}
